<iv-live-card-chart
  [cardId]="cardId"
  statistic
  [statisticElementName]="'Add chart to card'"
  *ngFor="let cardId of ($cardIds | async)"
>
</iv-live-card-chart>
